import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { showAlertModal } from '../../../../actions';
import FormWrapper from '../FormWrapper';
import Dialog from '../../../common/Dialog';

class ViewForm extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      bID: '',
      name: '',
      customerId: 'none',
      cams: [],
      selectedCams: [],
      viewEdit: false,
      showDeleteViewPrompt: false
    }
  }

  componentDidMount(){
    if(this.props.view){
      // we are editing a current site
      this.setState({
        bID: this.props.view.bID,
        name: this.props.view.sName,
        customerId: this.props.view.bCustomerID,
        customerName: this.props.view.sCustomerName,
        cams: this.props.view.sCams ? JSON.parse(this.props.view.sCams) : [],
        selectedCams: this.props.view.sCams ? JSON.parse(this.props.view.sCams) : [],
        viewEdit: true,
        showDeleteViewPrompt: false
      })
    }
  };

  componentDidUpdate() {
    if(this.props.view && this.props.view.bID && this.props.view.bID !== this.state.bID){
      this.setState({
        bID: this.props.view.bID,
        name: this.props.view.sName,
        customerId: this.props.view.bCustomerID,
        customerName: this.props.view.sCustomerName,
        cams: this.props.view.sCams ? JSON.parse(this.props.view.sCams) : [],
        selectedCams: this.props.view.sCams ? JSON.parse(this.props.view.sCams) : [],
        viewEdit: true,
        showDeleteViewPrompt: false
      })
    }
  };

  handleChange = (e, type) => {
    if(type === 'customerId'){
      let targetCustomer = this.props.customers.find(customer => customer.bID === parseInt(e.target.value));
      this.setState({ selectedCams: [], customerName: targetCustomer ? targetCustomer.sName : 'None' })
    };
    if(type === 'selectedCams'){
      let value = parseInt(e.target.value)
      // if cam is already in selected Cams, remove it - otherwise add it
      let tempSelected = [...this.state.selectedCams];
      if(tempSelected.includes(value)){
        tempSelected = tempSelected.filter(cam => cam !== value);
      } else {
        tempSelected.push(value);
      };
      this.setState({ selectedCams: tempSelected });
      return;
    }

    this.setState({ [type]: e.target.value });
  };

  onSubmit = async() => {
    if(this.state.name.trim() === '' || this.state.customerId === 'none' ) {
      this.props.showAlertModal(['WARNING', 'Site name and customer must be provided. Please revise.'])
      return;
    };

    if(this.state.selectedCams.length < 1) {      
      this.props.showAlertModal(['WARNING', 'No cameras have been selected for the current view. Please select cameras.'])
      return;
    };

    // if user is a local admin, that means he can only see cameras under the same customer
    // a view under Dividia can contain cameras from different customers
    // if a user is a local admin modifying a Dividia view, then we should retain the other cameras in this view that belongs from other customers
    let sCams = [...this.state.selectedCams]
    // if (this.props.user.bRole === 2 && parseInt(this.state.customerId) === 1) {
    //   this.state.cams.forEach(cID => {
    //     let cam = this.props.cameras.find(c => c.bID === cID)
    //     if (!sCams.includes(cID) && (!cam || cam.bCustomerID !== parseInt(this.state.customerId))) {
    //       sCams.push(cID)
    //     }
    //   })
    //   this.setState({selectedCams: sCams})
    // }

    const reqBody = {
      "id": this.state.viewEdit ? this.props.view.bID : null,
      "name": this.state.name,
      "customerId": parseInt(this.state.customerId),
      "cams": JSON.stringify(sCams)
    };

    await axios({
      method: 'post',
      url: this.props.cloudAPI + 've/view?device=' + this.props.deviceList[0],
      headers: {
        'Content-Type': 'Application/json',
        'Authorization': 'Bearer ' + this.props.token
      },
      withCredentials: true,
      data: reqBody

    }).then(response => {
      // insert returns new id in response.data.data[0], update returns null in response.data.data[0]
      this.props.showAlertModal(['SUCCESS', 'View details successfully saved.'])

      this.props.updateData('view', {
        bID: (this.state.viewEdit) ? this.props.view.bID : response.data.data[0],
        sName: this.state.name,
        bCustomerID: parseInt(this.state.customerId),
        sCustomerName: this.state.customerName,
        sCams: JSON.stringify(this.state.selectedCams),
      })

      !this.state.viewEdit && this.props.closeForm()

    }).catch(error => {
      console.log(error)
      this.props.showAlertModal(['ERROR', 'Unable to save view details.'])
    })
  };

  undoEdit = () => {
    this.setState({
      bID: this.props.view.bID,
      name: this.props.view.sName,
      customerId: this.props.view.bCustomerID,
      customerName: this.props.view.sCustomerName,
      cams: this.props.view.sCams ? JSON.parse(this.props.view.sCams) : [],
      selectedCams: this.props.view.sCams ? JSON.parse(this.props.view.sCams) : [],
      viewEdit: true,
      showDeleteViewPrompt: false
    });
  };

  promptDeleteView = () => {
    this.setState({ showDeleteViewPrompt: true });
  };

  deleteView = async (view) => {
    const reqBody = {
      "id": this.props.view.bID,
      "del": 1,
    };

    await axios({
      method: 'post',
      url: `${this.props.cloudAPI}ve/view?device=${this.props.deviceList[0]}`,
      headers: {
        'Content-Type': 'Application/json',
        'Authorization': 'Bearer ' + this.props.token
      },
      withCredentials: true,
      data: reqBody

    }).then(response => {
      this.props.showAlertModal(['SUCCESS', 'View successfully deleted.'])
      this.props.updateData('view', {}, true)
      this.props.closeForm();

    }).catch(error => {
      console.log(error)
      this.props.showAlertModal(['ERROR', 'Unable to delete view.'])
      this.setState({ showDeleteViewPrompt: false })
    })
  }

  onBlur = (e) => {
    if (this.props.view) {
      if ((this.state.name !== this.props.view.sName)
        || (parseInt(this.state.customerId) !== parseInt(this.props.view.bCustomerID))
        // for arrays/objects, make sure to parse, sort and stringify before comparing as equality comparison does not compare properly on multi-level data
        || (JSON.stringify(this.state.selectedCams.sort()) !== JSON.stringify(JSON.parse(this.props.view.sCams).sort()))) {
          this.props.onBlur(e, this.onSubmit)
      }

    // new
    } else {
      if (this.state.name.trim() !== '' || this.state.customerId !== 'none') {
          this.props.onBlur(e, this.onSubmit)
      }
    }
  }

  render() {
    return (
      <FormWrapper heading={this.state.viewEdit ? "Edit View" : "New View"}
                   onBlur={this.onBlur}
                   closeForm={this.props.closeForm}
                   onSubmit={this.onSubmit}
                   onDelete={this.promptDeleteView}
                   edit={this.state.viewEdit}
                   undoEdit={this.undoEdit} >

        <div style={{ width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: this.state.viewEdit ? '1vmin' : '4vmin', marginBottom: '1.6vmin', marginRight: this.state.viewEdit ? '1vmin' : 0 }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Name:</p>
            <input
              name="name"
              type="text"
              value={this.state.name}
              style={{ fontSize: '1.6vmin', width: '50%' }}
              onChange={(e) => this.handleChange(e, 'name')} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: this.state.viewEdit ? '1vmin' : '4vmin', marginBottom: '1.6vmin', marginRight: this.state.viewEdit ? '1vmin' : 0 }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Customer:</p>
            <select value={this.state.customerId} onChange={e => this.handleChange(e, 'customerId')} style={{ fontSize: '1.6vmin', width: '50%' }}>
              <option value={'none'}>None</option>
              {this.props.customers.map( c => (
                    <option key={c.bID} value={c.bID}>{c.sName}</option>
                ))
              }
            </select>
          </div>

          <div style={{ marginLeft: this.state.viewEdit ? '1vmin' : '4vmin', marginBottom: '1.6vmin', marginRight: this.state.viewEdit ? '1vmin' : 0 }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', marginBottom: '1vmin' }}>Cams: </p>
            <div>
              {this.props.cameras.filter(c => 
                // show everything if user is a master admin and customer is Dividia, else, show only based on customer
                (((this.props.user.bRole === 1 && parseInt(this.state.customerId) === 1) || (parseInt(this.state.customerId) === c.bCustomerID)) && c.bProfile === 1)).map( c => (
                  <div key={c.bID} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '1vmin', marginLeft: '8vmin' }}>
                    <input name="cam" type="checkbox" value={c.bID} checked={this.state.selectedCams.includes(c.bID)} style={{ fontSize: '1.6vmin' }} onChange={(e) => this.handleChange(e, 'selectedCams')} />
                    <p style={{ margin: 0, fontSize: '1.6vmin', marginLeft: '1vmin' }}>{`${c.sCustomerName} - ${c.sDeviceName} : ${c.sName && c.sName.length > 0 ? c.sName : `Cam ${c.bCamera}`} (${c.bID})`}</p>
                  </div>
                ))
              }
            </div>
          </div>
        </div>

        {this.state.showDeleteViewPrompt &&
          <Dialog
            boxStyle={{width: '50vmin'}}
            title="WARNING"
            content={
              <div>
                <p>Are you sure you want to delete this view?</p>
                <p>{this.props.view.sName}</p>
                <p style={styles.dialogHighlight}>Users will no longer have access to this view once removed.</p>
                <p>This action cannot be undone.</p>
              </div>
            }
            buttons={[
              {label: 'Delete', onClick: () => this.deleteView(this.props.view)},
              {label: 'Cancel', onClick: () => this.setState({ showDeleteViewPrompt: false })},
            ]}
          />
        }

      </FormWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  const { user } = state.auth
  return { user }
}
export default connect(mapStateToProps, { showAlertModal } )(ViewForm)

const styles = {
  dialogHighlight: {
    fontWeight: 'bold',
  },
}